import { Status } from '../api/enumerations';

export const STATUS_COLORS: Record<Status, string> = {
  [Status.ENTRANCE]: '#7B3FF2',
  [Status.PEPT]: '#B71C1C',
  [Status.SCHEDULE]: '#1976D2',
  [Status.INSPECTION]: '#F9A825',
  [Status.SAMPLE_CREATION]: '#00897B',
  [Status.CALCULATION]: '#5E35B1',
  [Status.REPORT]: '#039BE5',
  [Status.REVISION]: '#43A047',
  [Status.ARCHIVED]: '#616161',
};

export const FUNNEL_ORDER: Status[] = [
  Status.ENTRANCE,
  Status.PEPT,
  Status.SCHEDULE,
  Status.INSPECTION,
  Status.SAMPLE_CREATION,
  Status.CALCULATION,
  Status.REPORT,
  Status.REVISION,
  Status.ARCHIVED,
];

export const STATUS_OPTIONS: Status[] = FUNNEL_ORDER;
